import addressee from '../../defaultFieldDefinitions/Addressee';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import streetName from '../../defaultFieldDefinitions/StreetName';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import townCity from '../../defaultFieldDefinitions/TownCity';
import county from '../../defaultFieldDefinitions/County';
import postCode from '../../defaultFieldDefinitions/PostCode';

const FieldDefinitionNZ = [
  addressee,
  companyName,
  {
    ...streetName,
    name: 'streetName',
    label: 'checkout.address.field.label.address.text',
    required: true,
  },
  {
    ...addressLine2,
    name: 'addressLine2',
    label: 'checkout.address.field.label.AUaddress2.text',
  },
  townCity,
  {
    ...county,
    name: 'county',
    label: 'checkout.address.field.label.suburb.text',
  },
  postCode,
];

export default FieldDefinitionNZ;
